<div class="my-4 mx-5" >
    <div class="wrapper mb-2">
        <div class="row align-items-center m-0 mb-2" style="padding: 10px;">
            <img class="p-2" src="./assets/icons/arrow.svg">
            <span class="label-title ml-2 mr-3">Dados da Empresa</span>
        </div>
        <mat-tab-group style="margin-top: 3rem" class="tab-assingnor-info" animationDuration="0ms" >
            <mat-tab label="Informações Cadastrais">
                <app-dado-empresa-info-cadastrais></app-dado-empresa-info-cadastrais>
            </mat-tab>
            <mat-tab *ngFor="let type of addressTypes; let index = index" [label]="type.assignorLabel">
                <app-dado-empresa-endereco [addressTypeId]="type.addressTypeId"></app-dado-empresa-endereco>
            </mat-tab>
            <mat-tab label="Configurações">
                <div class="container-fluid" >
                    <div class="row">
                        <div class="col-lg-6 col-md-6 col-sm-12 py-2">
                            <mat-slide-toggle color="primary" [checked]="notaFiscalDetalhada" (change)="nfsEnableDisable($event.checked)">
                                Nota Fiscal Detalhada
                            </mat-slide-toggle>
                            <br>
                            <mat-form-field style="width: 65%;" *ngIf="inputNotaFiscalDetalhada">
                                <mat-label>Descrição Nota Fiscal</mat-label>
                                <input matInput id="labelDetailNfs" type="text" [(ngModel)]="textoNotaFiscalDetalhada">
                                <button mat-button mat-flat-button matSuffix class="mat-success" aria-label="done" (click)="nfsSave()">
                                    <mat-icon>done</mat-icon>
                                </button>
                            </mat-form-field>   
                        </div>
                    </div>
                </div>
                <div class="container-fluid mt-3" *ngIf="temContaSeuValeLog" >
                    <span class="label-title mb-3" style="font-size: 1.1rem;">Configurações Logísticas</span>
                    <div class="row">
                        <div class="col-lg-6 col-md-6 col-sm-12 py-2">
                            <div class="custom-input-container">
                                <mat-slide-toggle color="primary" [checked]="settingsLog?.receipt" (change)="receiptEnableDisable($event.checked)">
                                    Obrigatório leitura do cupom fiscal
                                </mat-slide-toggle>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12 py-2">
                            <div class="custom-input-container">
                                <mat-slide-toggle color="primary" [checked]="settingsLog?.odometer" (change)="odometerEnableDisable($event.checked)">
                                    Obrigatório leitura de odômetro
                                </mat-slide-toggle>
                            </div>
                        </div>
                        <!-- <div class="col-lg-6 col-md-6 col-sm-12 py-2">
                            <div class="custom-input-container">
                                <mat-slide-toggle color="primary">
                                    Todos condutores pode todos veículos
                                </mat-slide-toggle>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12 py-2">
                            <div class="custom-input-container">
                                <mat-slide-toggle color="primary">
                                    Pedir consumo medio
                                </mat-slide-toggle>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12 py-2">
                            <div class="custom-input-container">
                                <mat-slide-toggle color="primary">
                                    Pedir tipo de combustivel
                                </mat-slide-toggle>
                            </div>
                        </div> -->
                    </div>
                </div>
            </mat-tab>
        </mat-tab-group>
        <div class="row component-box button-container mb-3 mt-0 pb-4 px-4">
            <div class="col-12 text-right">
                <button type="button" class="custom-button-full" (click)="edit()">
                    Editar Dados
                </button>
            </div>
        </div>
    </div>
</div>

